import { useContext, useState } from "react"
import { loginFields } from "../../constants/formFields"
import FormAction from "../forms/FormAction"
import FormExtra from "../forms/FormExtra"
import Input from "../forms/Input"
import { Credentials, FieldState, UserAuth } from "../../Interfaces"
import { useNavigate } from "react-router-dom"
import AuthContext from "../../context/authProvider"
import { authService } from "../../services/authService"
import PasswordResetModal from "../modals/PasswordResetModal"

const fields = loginFields
let fieldsState: FieldState = {}
fields.forEach((field) => (fieldsState[field.name] = ""))

export default function Login() {
  const [loginFormState, setLoginFormState] = useState(fieldsState)
  const { setAuth } = useContext(AuthContext) as unknown as { auth: UserAuth; setAuth: (auth: UserAuth) => void }
  const navigate = useNavigate()
  const [showPasswordReset, setShowPasswordReset] = useState(false)
  const [userId, setUserId] = useState<number | null>(null)

  const handleChange = (e: { target: { name: string; value: string } }) => {
    setLoginFormState({ ...loginFormState, [e.target.name]: e.target.value })
  }

  const performLogin = async () => {
    console.log('Starting login process...')
    localStorage.removeItem("token")
    const credentials = loginFormState as unknown as Credentials
    console.log('Login credentials:', { email: credentials.email, password: '***' })
    try {
      const { accessToken, user } = await authService.getAuthFromCredentials(credentials)
      console.log('Login successful, token received:', !!accessToken, 'user:', user)
      if (accessToken && user) {
        if (user.needsPasswordReset) {
          console.log('User needs password reset')
          setUserId(user.id)
          setShowPasswordReset(true)
        } else {
          console.log('Setting auth and navigating to /app')
          setAuth({ token: accessToken, user: user })
          navigate("/app")
        }
      }
    } catch (err) {
      console.error('Login error:', err)
      alert(err)
    }
  }

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault()
    await performLogin()
  }

  const handlePasswordResetComplete = async () => {
    setShowPasswordReset(false)
    setUserId(null)
    // After password reset, we need to log the user in again
    await performLogin()
  }

  return (
    <>
      <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
        <div className="-space-y-px">
          {fields.map((field) => (
            <Input
              className="bg-gray-50 border-gray-300"
              key={field.id}
              handleChange={handleChange}
              value={loginFormState[field.id]}
              labelText={field.labelText}
              labelFor={field.labelFor}
              id={field.id}
              name={field.name}
              type={field.type}
              autoComplete={field.autoComplete}
              isRequired={field.isRequired}
              placeholder={field.placeholder}
            />
          ))}
        </div>

        <FormExtra />
        <FormAction handleSubmit={handleSubmit} text="Login" />
      </form>

      {showPasswordReset && userId != null && (
        <PasswordResetModal
          userId={userId}
          onPasswordResetComplete={handlePasswordResetComplete}
        />
      )}
    </>
  )
}
